import * as React from 'react';

import { ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, withStyles, Theme, WithStyles, CircularProgress, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { UsersAPI, errorToString } from 'src/api';
import strings from 'src/strings';
import { GoogleLogin, GoogleLoginResponseOffline, GoogleLogout } from 'react-google-login';
import { withToast, WithToast } from '../HOC/Toast';
import { DataSourceType, DataSource as DS } from 'src/api/models/datasource';
import FacebookLogin, { ReactFacebookLoginInfo } from 'react-facebook-login';
interface DataSourceProps extends WithStyles<typeof styles>, WithToast {
    className?: string;
}
interface DataSourceState {
    loading_states: {
        [key in DataSourceType]: boolean
    }
    sources: DS[]
}
class DataSource extends React.Component<DataSourceProps, DataSourceState> {

    constructor(props: DataSourceProps) {
        super(props);
        this.state = {
            loading_states: {
                google_adwords: true,
                google_analytics: true,
                facebook: true
            },
            sources: []
        }
        this.googleResponse = this.googleResponse.bind(this)
        this.facebookeResponse = this.facebookeResponse.bind(this)
        this.googleAdwordResponse = this.googleAdwordResponse.bind(this)
    }

    private changeLoadingState(key: DataSourceType, loading: boolean) {
        let states = this.state.loading_states;
        states[key] = loading
        return states
    }

    private facebookeResponse(response: ReactFacebookLoginInfo) {
        this.setState({ loading_states: this.changeLoadingState(DataSourceType.FACEBOOK, true) })
        UsersAPI.addDatasource(response.accessToken, DataSourceType.FACEBOOK).then(source => {
            this.setState({ loading_states: this.changeLoadingState(DataSourceType.FACEBOOK, false), sources: this.state.sources.concat(source) })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
            this.setState({ loading_states: this.changeLoadingState(DataSourceType.FACEBOOK, false) })
        })
    }

    private googleResponse(response: (GoogleLoginResponseOffline) & { error?: string }) {
        if (response.error) {
            this.props.showToast('error', strings.accessDenied)
        } else {
            this.setState({ loading_states: this.changeLoadingState(DataSourceType.GOOGLE_ANALYTICS, true) })
            UsersAPI.addDatasource(response.code, DataSourceType.GOOGLE_ANALYTICS).then(source => {
                this.setState({ loading_states: this.changeLoadingState(DataSourceType.GOOGLE_ANALYTICS, false), sources: this.state.sources.concat(source) })
            }).catch(err => {
                errorToString(err).forEach(error => {
                    this.props.showToast('error', error)
                })
                this.setState({ loading_states: this.changeLoadingState(DataSourceType.GOOGLE_ANALYTICS, false) })
            })
        }
    }

    private googleAdwordResponse(response: (GoogleLoginResponseOffline) & { error?: string }) {
        if (response.error) {
            this.props.showToast('error', strings.accessDenied)
        } else {
            this.setState({ loading_states: this.changeLoadingState(DataSourceType.GOOGLE_ADWORDS, true) })
            UsersAPI.addDatasource(response.code, DataSourceType.GOOGLE_ADWORDS).then(source => {
                this.setState({ loading_states: this.changeLoadingState(DataSourceType.GOOGLE_ADWORDS, false), sources: this.state.sources.concat(source) })
            }).catch(err => {
                errorToString(err).forEach(error => {
                    this.props.showToast('error', error)
                })
                this.setState({ loading_states: this.changeLoadingState(DataSourceType.GOOGLE_ADWORDS, false) })
            })
        }
    }

    private removeDatasource(source: DS) {
        this.setState({ loading_states: this.changeLoadingState(source.type, true) })
        UsersAPI.deleteDatasource(source).then(() => {
            this.setState({ loading_states: this.changeLoadingState(source.type, false), sources: this.state.sources.filter(s => s.id != source.id) })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
            this.setState({ loading_states: this.changeLoadingState(source.type, false) })
        })
    }

    componentDidMount() {
        UsersAPI.getDatasources().then(sources => {
            this.setState({ loading_states: { google_adwords: false, facebook: false, google_analytics: false }, sources });
            (window as any).FB.getLoginStatus((data: any) => {
                if (data.status == 'connected') {
                    this.facebookeResponse(data.authResponse)
                } else {
                    this.setState({ sources: this.state.sources.filter(s => s.type != DataSourceType.FACEBOOK) })
                }
            })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
            this.setState({ loading_states: { google_adwords: false, facebook: false, google_analytics: false } })
        });
    }

    public render() {
        const { classes } = this.props
        return <div className={this.props.className}>
            <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>{strings.facebook}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ display: 'flex' }}>
                    <Typography style={{ flexGrow: 2 }}>
                        {strings.datasource_addFacebookDescription}
                    </Typography>
                    {this.state.loading_states.facebook && <CircularProgress size={30} style={{}} />}

                    {this.state.sources.find(s => s.type == DataSourceType.FACEBOOK) != undefined && !this.state.loading_states.facebook &&
                        <Button variant="outlined" color="secondary" onClick={() => {
                            this.removeDatasource(this.state.sources.find(s => s.type == DataSourceType.FACEBOOK)!)
                        }}>
                            {strings.datasource_disconnect}
                        </Button>}

                    {this.state.sources.find(s => s.type == DataSourceType.FACEBOOK) == undefined && !this.state.loading_states.facebook && <FacebookLogin
                        appId="359193168169308"
                        autoLoad={true}
                        size='small'
                        buttonStyle={{ fontSize: '12px' }}
                        onFailure={(failure) => {
                            this.props.showToast('error', strings.accessDenied)
                        }}
                        callback={this.facebookeResponse}
                        scope='manage_pages'
                        fields="name,email"
                    />}
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>{strings.googleAnalytics}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ display: 'flex' }}>
                    <Typography style={{ flexGrow: 2 }}>
                        {strings.datasource_addGoogleDescription}
                    </Typography>
                    {this.state.loading_states.google_analytics && <CircularProgress size={30} style={{}} />}

                    {this.state.sources.find(s => s.type == DataSourceType.GOOGLE_ANALYTICS) != undefined && !this.state.loading_states.google_analytics &&
                        <Button variant="outlined" color="secondary" onClick={() => {
                            this.removeDatasource(this.state.sources.find(s => s.type == DataSourceType.GOOGLE_ANALYTICS)!)
                        }}>
                            {strings.datasource_disconnect}
                        </Button>}

                    {this.state.sources.find(s => s.type == DataSourceType.GOOGLE_ANALYTICS) == undefined && !this.state.loading_states.google_analytics && <GoogleLogin
                        clientId="160764908929-tqroisl87rclqi4ps75qu20d7b48mklc.apps.googleusercontent.com"
                        buttonText="Login"
                        accessType='offline'
                        responseType='code'
                        prompt='consent'
                        scope='https://www.googleapis.com/auth/analytics.readonly'
                        disabled={this.state.loading_states.google_analytics}
                        onSuccess={this.googleResponse}
                        onFailure={this.googleResponse}
                    />}
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>{strings.googleAdwords}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ display: 'flex' }}>
                    <Typography style={{ flexGrow: 2 }}>
                        {strings.datasource_addGoogleAdwordsDescription}
                    </Typography>
                    {this.state.loading_states.google_adwords && <CircularProgress size={30} style={{}} />}

                    {this.state.sources.find(s => s.type == DataSourceType.GOOGLE_ADWORDS) != undefined && !this.state.loading_states.google_adwords &&
                        <Button variant="outlined" color="secondary" onClick={() => {
                            this.removeDatasource(this.state.sources.find(s => s.type == DataSourceType.GOOGLE_ADWORDS)!)
                        }}>
                            {strings.datasource_disconnect}
                        </Button>}

                    {this.state.sources.find(s => s.type == DataSourceType.GOOGLE_ADWORDS) == undefined && !this.state.loading_states.google_adwords && <GoogleLogin
                        clientId="160764908929-tqroisl87rclqi4ps75qu20d7b48mklc.apps.googleusercontent.com"
                        buttonText="Login"
                        accessType='offline'
                        responseType='code'
                        prompt='consent'
                        scope='https://www.googleapis.com/auth/adwords'
                        disabled={this.state.loading_states.google_adwords}
                        onSuccess={this.googleAdwordResponse}
                        onFailure={this.googleAdwordResponse}
                    />}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </div>
    }
}
const styles = (theme: Theme) => ({
    root: {
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
});

export default withToast(withStyles(styles)(DataSource))


// WEBPACK FOOTER //
// ./src/components/Client/Datasource.tsx